// extracted by mini-css-extract-plugin
export var layout = "Layout-module--layout--1USp3";
export var contents = "Layout-module--contents--dkbf3";